import AsyncSelect, { Option, type AsyncSelectBaseProps } from "./AsyncSelect";
import { CitizenshipService } from "@/services/citizenship";
import { useTranslation } from "react-i18next";
import { forwardRef, useCallback } from "react";
import appConfiguration from "./cfg/AppCfg";
import { useCreateDataTableOptions } from "./data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { ReadCitizenship } from "@/types/citizenship";
import { FilterType } from "@/lib/filters";

interface CitizenshipSelectProps extends AsyncSelectBaseProps {
  className?: string;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, CitizenshipSelectProps>(
  function CitizenshipSelect({ defaultItem, ...props }, ref) {
    const { t } = useTranslation();

    const name = "citizenshipSelect";
    const options = useCreateDataTableOptions<ReadCitizenship>(name);
    const queryKey = useDynamicQueryParams<ReadCitizenship>(name, options);

    const onFilter = useCallback(
      (filterValue: string) => {
        options.setFilterValue("name", {
          value: filterValue,
          filter: FilterType.IncludesString,
        });
      },
      [options],
    );

    return (
      <AsyncSelect
        queryKey={queryKey}
        queryFn={() =>
          CitizenshipService.getList({
            filters: options.filters,
            limit: appConfiguration.selectComponentsPaginationLimit,
          })
        }
        enableFilter={true}
        onFilter={onFilter}
        placeholder={t("citizenshipSelect.placeholder")}
        loadingLabel={t("citizenshipSelect.loading")}
        searchLabel={t("citizenshipSelect.search")}
        noResultsLabel={t("citizenshipSelect.noResults")}
        {...props}
        ref={ref}
        className="w-full"
        defaultItem={defaultItem}
      />
    );
  },
);
